<template>
  <v-card flat>
    <v-card-text>
      <v-card outlined class="rounded-lg ma-2">
        <v-card-text class="ma-0">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap justify-center align-center>
              <v-flex xs11 sm11 md11 lg11>
                <b>{{ $t("onechat.con1") }}</b> <br />
                <v-layout row wrap justify-start mt-2>
                  <v-flex xs11 sm3 md2 lg2 class="mr-2">
                    <v-btn
                      block
                      outlined
                      color="#077893"
                      @click="Fn_SelectTypeDepartment('SentAll')"
                      dark
                      >{{ $t("onechat.con3") }}</v-btn
                    >
                  </v-flex>
                  <v-flex xs11 sm4 md2 lg2 class="mr-2">
                    <v-btn
                      block
                      outlined
                      color="#077893"
                      @click="Fn_SelectTypeDepartment('SentDepartment')"
                      dark
                      >{{ $t("onechat.con2") }}</v-btn
                    >
                  </v-flex>
                  <v-flex xs11 sm4 md2 lg2>
                    <v-btn
                      block
                      outlined
                      color="#077893"
                      @click="Fn_SelectTypeDepartment('SentId')"
                      dark
                      >{{ $t("onechat.con4") }}</v-btn
                    >
                  </v-flex>
                </v-layout>
                <!-- <div class="d-flex align-center">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    color="#077893"
                    label="OneAccount ID"
                  ></v-text-field>
                  <v-btn class="ml-3" dark dense color="#077893">search</v-btn>
                </div> -->
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              justify-center
              align-start
              v-if="ShowDetails"
              mt-4
            >
              <v-flex xs11 md6 lg6 pa-1 pr-6>
                <v-card outlined>
                  <v-card-title class="pa-2">
                    <v-layout row wrap justify-start align-center>
                      <v-flex xs10 md10 lg6>
                        <b class="text-left">{{ $t("onechat.nameSelect") }}</b>
                      </v-flex>

                      <v-flex xs10 md10 lg6 class="text-end">
                        <!-- <v-btn
                          color="#077893"
                          dark
                          rounded
                          @click="Fn_EditEmployee(SelectNamePosition)"
                          >{{ $t("onechat.editName") }}</v-btn
                        > -->
                        <v-chip
                          class="ma-2 white--text"
                          color="#077893"
                          v-if="$t('default') === 'th'"
                        >
                          จำนวนทั้งหมด&nbsp;
                          <b> {{ SelectNamePosition.length }} </b> &nbsp;คน
                        </v-chip>
                        <v-chip class="ma-2 white--text" color="#077893" v-else>
                          Total&nbsp;
                          <b> {{ SelectNamePosition.length }} </b> &nbsp;person
                        </v-chip>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-card-text style="max-height: 350px; overflow: auto">
                    <!-- {{ SelectNamePosition }} -->
                    <div
                      class="d-flex align-center hover"
                      v-for="(item, i) in SelectNamePosition"
                      :key="i"
                    >
                      <p
                        class="ma-0 pl-3 black--text"
                        v-if="$t('default') === 'th'"
                      >
                        {{ item.NameTh }}
                      </p>
                      <p class="ma-0 pl-3 black--text" v-else>
                        {{ item.NameEng }}
                      </p>
                      <v-spacer></v-spacer>
                      <p class="ma-0">
                        <v-btn icon color="error" @click="deleteItem(i)">
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs11 sm5 lg5 md5>
                <b>{{ $t("onechat.text5") }}</b> <br />
                <v-radio-group
                  @change="Fn_SelectTypeConsent"
                  v-model="ConsentType"
                  :rules="[(v) => !!v]"
                  row
                >
                  <v-radio
                    :label="$t('onechat.text6')"
                    color="#077893"
                    value="SentGeneral"
                  >
                  </v-radio>
                  <v-radio
                    :label="$t('onechat.text7')"
                    color="#077893"
                    value="SentGroup"
                  >
                  </v-radio>
                </v-radio-group>
                <div v-if="ConsentType === 'SentGeneral'">
                  <b class="red--text mr-1">*</b>
                  <b>{{ $t("onechat.text8") }} </b>
                  <v-select
                    dense
                    :items="ItemPolicy"
                    :label="$t('onechat.text8')"
                    :rules="[(v) => !!v]"
                    item-text="Title"
                    v-model="SelectPolicy"
                    item-value="PolicyId"
                    outlined
                  >
                  </v-select>
                  <b class="red--text mr-1">*</b>
                  <b>{{ $t("onechat.text9") }} </b>
                  <v-select
                    v-if="ConsentType === 'SentGeneral'"
                    dense
                    :items="ItemConsentGeneral"
                    :label="$t('onechat.text9')"
                    :rules="[(v) => !!v]"
                    item-text="HeaderConsent"
                    v-model="SelectConsentGeneral"
                    item-value="ConsentId"
                    outlined
                  >
                  </v-select>
                  <b class="red--text mr-1">*</b>
                  <b>{{ $t("onechat.textGroupSend") }} </b>
                  <v-text-field
                    :rules="[(v) => !!v]"
                    :label="$t('onechat.textGroupSend')"
                    v-model="GroupSend"
                    outlined
                    dense
                  ></v-text-field>
                  <!-- <b class="red--text mr-1">*</b> -->
                  <b>{{ $t("onechat.showPolicy") }} </b>
                  <v-switch
                    class="mt-1"
                    color="#077893"
                    v-model="ShowPolicy"
                    inset
                    :label="
                      ShowPolicy === true
                        ? $t('onechat.show')
                        : $t('onechat.hide')
                    "
                  ></v-switch>
                </div>
                <div v-else-if="ConsentType === 'SentGroup'">
                  <b class="red--text mr-1">*</b>
                  <b>{{ $t("onechat.text10") }} </b>
                  <v-select
                    dense
                    :items="ItemConsentGroup"
                    :label="$t('onechat.text10')"
                    :rules="[(v) => !!v]"
                    item-text="GroupName"
                    v-model="SelectConsentGroup"
                    item-value="GroupId"
                    outlined
                  >
                  </v-select>
                  <b class="red--text mr-1">*</b>
                  <b>{{ $t("onechat.textGroupSend") }} </b>
                  <v-text-field
                    :rules="[(v) => !!v]"
                    :label="$t('onechat.textGroupSend')"
                    v-model="GroupSend"
                    outlined
                    dense
                  ></v-text-field>
                  <!-- <b class="red--text mr-1">*</b> -->
                  <b>{{ $t("onechat.showPolicy") }} </b>
                  <v-switch
                    class="mt-1"
                    color="#077893"
                    v-model="ShowPolicy"
                    inset
                    :label="
                      ShowPolicy === true
                        ? $t('onechat.show')
                        : $t('onechat.hide')
                    "
                  ></v-switch>
                </div>
              </v-flex>
            </v-layout>
            <!-- <v-layout row wrap v-else>
              <v-flex xs11 md5 lg5>
                <b class="red--text mr-1">*</b>
                <b>{{ $t("onechat.showPolicy") }} </b>
                <v-switch
                  class="mt-1"
                  color="#077893"
                  v-model="ShowPolicy"
                  inset
                  :label="
                    ShowPolicy === true
                      ? $t('onechat.show')
                      : $t('onechat.hide')
                  "
                ></v-switch>
              </v-flex>
            </v-layout> -->
          </v-form>
          <v-layout row wrap justify-end mb-2 mr-4 v-if="ShowSendBtn">
            <v-flex xs3 md2 lg2>
              <v-btn
                block
                dark
                color="#077893"
                :loading="LoadingSentConsent"
                @click="Fn_Save()"
              >
                {{ $t("onechat.send") }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <br />
      <br />
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogTypeDepartment
        :show="DialogTypeDepartment"
        :typeDepartment="SelectDepartment"
        @closeDialog="DialogTypeDepartment = false"
        @confirmAccount="Fn_ConfirmEmployee"
      />
      <DialogAllEmployee
        :show="DialogAllEmployee"
        :editName="EditNamePosition"
        :typeDepartment="SelectNamePosition"
        @closeDialog="DialogAllEmployee = false"
        @confirmEmployee="Fn_ConfirmEmployee"
      />
      <DialogConsentEmployeeId
        :show="DialogConsentEmployeeId"
        :typeDepartment="SelectNamePosition"
        @closeDialog="DialogConsentEmployeeId = false"
        @confirmEmployee="Fn_ConfirmEmployee"
      />
      <DialogListGeneralConsent
        :show="DialogListGeneral"
        :_detail="ItemsConsent"
        @closeDialogDelete="DialogListGeneral = false"
      />
      <DialogListGroupConsent
        :show="DialogListGroup"
        :_detail="ItemsConsent"
        @closeDialogDelete="DialogListGroup = false"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import DialogAllEmployee from "@/components/dialog/ConsentOnechat/DialogConsentAllEmployee.vue";
import DialogListGeneralConsent from "@/components/dialog/ConsentOnechat/DialogConsentGeneralOnechatCreate.vue";
import DialogConsentEmployeeId from "@/components/dialog/DialogConsentEmployeeId.vue";
import DialogListGroupConsent from "@/components/dialog/DialogConsentGroupOnechatCreate";
import DialogTypeDepartment from "@/components/dialog/DialogConsentTypeDepartment.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    OverlaySearch,
    DialogTypeDepartment,
    DialogAllEmployee,
    DialogListGeneralConsent,
    DialogListGroupConsent,
    DialogConsentEmployeeId,
  },
  data: function () {
    return {
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      ItemConsent: [],
      ItemCount: [],
      number: [],
      ItemsConsent: [],
      GroupSend: "",
      DialogListGeneral: false,
      DialogListGroup: false,
      ShowPolicy: false,
      DialogDelete: false,
      loadingDownloadData: false,
      LoadingSendOnechat: false,
      tab: null,
      items: ["ความยินยอมทั่วไป", "ความยินยอมแบบกลุ่ม"],
      valid: true,
      LoadingExcel: false,
      DialogTypeDepartment: false,
      DialogAllEmployee: false,
      DialogConsentEmployeeId: false,
      Title: "",
      RejectReason: "",
      DetailConsent: "",
      ExpirationDate: "",
      DepartmentId: "",
      ConsentType: "SentGeneral",
      DisabledPosition: false,
      SelectNamePosition: [],
      TypeSent: "",
      LoadingPosition: false,
      LoadingSentConsent: false,
      rows: [{ row: "" }],
      ItemsRole: [],
      ItemsDepartment: [],
      ItemsPosition: [],
      ItemPolicy: [],
      ItemConsentGeneral: [],
      ItemConsentGroup: [],
      ItemsCheckUser: [],
      EditNamePosition: [],
      SelectPolicy: "",
      SelectConsentGeneral: "",
      SelectConsentGroup: " ",
      SelectDepartment: "",
      SelectRole: "",
      TextPolicy: "",
      TextConsent: "",
      payloadUserOnechat: "",
      PathApi: "",
      LoadingSync: false,
      ShowSendBtn: false,
      ShowDetails: false,
      Itemsdata: "",
      AddItem: [],
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    ...mapGetters(["DataGroupOneChatSearch"]),
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },
    _DataGroupOneChatSearch: {
      get() {
        return this.DataGroupOneChatSearch || "-";
      },
    },
  },
  mounted() {},
  methods: {
    deleteItem(index) {
      this.SelectNamePosition.splice(index, 1);
      this.AddItem.splice(index, 1);
    },
    Fn_SelectTypeDepartment(TypeSent) {
      if (TypeSent === "SentDepartment") {
        this.DialogTypeDepartment = true;
      } else if (TypeSent === "SentAll") {
        this.SelectDepartment = "";
        this.SelectRole = "";
        this.DialogAllEmployee = true;
      } else if (TypeSent === "SentId") {
        this.DialogConsentEmployeeId = true;
      }
    },
    Fn_SelectTypeConsent() {
      if (this.ConsentType === "SentGeneral") {
        this.SelectPolicy = "";
        this.SelectConsentGeneral = "";
        this.Fn_GetPolicy();
        this.Fn_GetConsentGeneral();
      } else if (this.ConsentType === "SentGroup") {
        this.SelectConsentGroup = "";
        this.Fn_GetConsentGroup();
      }
    },
    async Fn_GetAllDepartment() {
      var payload = {
        TaxId: this._SelectTaxId,
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetAllDepartment",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            for (var i in response.data.Message) {
              var x = response.data.Message[i];
              this.ItemsDepartment.push(x);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDetailDepartment() {
      this.LoadingPosition = true;
      this.ItemsRole = [];

      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        DepartmentId: this.SelectDepartment.DepartmentId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetDetailDepartment",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingPosition = false;
          if (response.data.Status === "OK") {
            for (var i in response.data.Message) {
              var x = response.data.Message[i];
              this.ItemsRole.push(x);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.catch"),
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetAllEmployee() {
      this.LoadingPosition = true;
      // this.SelectNamePosition = []
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        PerPage: this.ItemPerPage,
        Page: this.Page,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/employee/all",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingPosition = false;
          if (response.data.Status === "OK") {
            this.ItemsPosition = response.data.Message.Employee;
            // for (var i in response.data.Message.Employee
            // ) {
            //   var x = response.data.Message[i]
            //   this.ItemsPosition.push(x)
            // }
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.ItemsPosition.length;

            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemsPosition) {
              this.ItemsPosition[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;

          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
      // } else {
      //   Toast.fire({
      //     icon: "warning",
      //     title: "กรุณาเลือกรูปแบบการส่ง",
      //   });
      // }
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGeneral() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsentGeneral = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      // this.loadingDownloadData = true
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_ConfirmEmployee(value) {
      for (let i = 0; i < value.length; i++) {
        this.$set(this.AddItem, this.AddItem.length, value[i]);
      }
      this.Fn_SelectTypeConsent();
      for (var i in value) {
        delete value[i].Email;
        delete value[i].TitleNameEng;
        delete value[i].TitleNameTh;
        var ItemsEmployee = this._DataGroupOneChatSearch.Consent;

        if (ItemsEmployee === undefined) {
          this.ShowDetails = true;
          this.ShowSendBtn = true;
          // this.AddItem.push(value);
          // this.AddItem.push(value);
          // this.SelectNamePosition = this.AddItem.concat(value);
          // this.AddItem.replace(/\[|\]/g, "");
          // this.SelectNamePosition.push(this.AddItem);
          // this.SelectNamePosition = this.AddItem;
          this.SelectNamePosition = this.AddItem.filter(function (
            item,
            index,
            self
          ) {
            return (
              index ===
              self.findIndex(function (t) {
                return t.NameTh === item.NameTh;
              })
            );
          });

          // this.Fn_GetPolicy()
          // this.Fn_GetConsentGeneral()
          // this.Fn_GetConsentGroup()
        } else if (ItemsEmployee.length > 0) {
          this.SelectNamePosition = value;
          this.ShowDetails = false;
          this.ShowSendBtn = true;
          this.SelectPolicy =
            this._DataGroupOneChatSearch.Detail.Policy[0].PolicyId;
          this.GroupSend = this._DataGroupOneChatSearch.Detail.GroupSend;
          this.ShowPolicy = this._DataGroupOneChatSearch.Detail;
          if (this._DataGroupOneChatSearch.Type === "General") {
            this.SelectConsentGeneral =
              this._DataGroupOneChatSearch.Detail.Consent[0].ConsentId;
          } else if (this._DataGroupOneChatSearch.Type === "Group") {
            this.SelectConsentGroup =
              this._DataGroupOneChatSearch.Detail.Consent[0].GroupId;
          }
        }
      }
    },
    Fn_Save() {
      if (this.$refs.form.validate()) {
        if (this.ConsentType === "SentGeneral") {
          this.SelectConsentGroup = "";
        } else if (this.ConsentType === "SentGroup") {
          this.SelectConsentGeneral = "";
        }
        this.LoadingSentConsent = true;
        for (var i in this.SelectNamePosition) {
          delete this.SelectNamePosition[i].Email;
          delete this.SelectNamePosition[i].Mobile;
        }

        if (this._DataGroupOneChatSearch.Consent === undefined) {
          this.PathApi = "onechat/OnePlatform/GetConsent";
          this.$store.dispatch("SET_DATA_GROUP_ONECHAT", []);
        } else if (this._DataGroupOneChatSearch.Consent.length > 0) {
          this.PathApi = "onechat/OnePlatform/GetConsentAddOn";
          this.SelectPolicy =
            this._DataGroupOneChatSearch.Detail.Policy[0].PolicyId;
        }
        this.payloadUserOnechat = {
          UserName: this.$cookies.get("OneUsername"),
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          Receiver: this.SelectNamePosition,
          ConsentGroupId: this.SelectConsentGroup,
          Consent: this.SelectConsentGeneral,
          PolicyId: this.SelectPolicy,
          UserId: this.$cookies.get("OneAccountId"),
          GroupSend: this.GroupSend,
          ShowPolicy: this.ShowPolicy,
        };

        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + this.PathApi,
            this.payloadUserOnechat
          )
          .then((response) => {
            this.LoadingSentConsent = false;
            if (response.data.Status === "OK") {
              this.ItemsConsent = response.data.Message;
              if (this.SelectConsentGroup === "") {
                this.DialogListGeneral = true;
              } else {
                this.DialogListGroup = true;
              }
            } else {
              this.LoadingSentConsent = false;
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingSentConsent = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    async Fn_SyncBot() {
      this.LoadingSync = true;
      const payload = {
        AccessToken: this.$cookies.get("OneAccessToken"),
        BusinessId: this.$cookies.get("BusinessId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/AddFrindBot",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingSync = false;
          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: "Sync CMP Bot Success",
            });
            // window.location.reload();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSync = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_EditEmployee(val) {
      if (this.TypeSent === "SentDepartment") {
        this.DialogTypeDepartment = true;
      } else if (this.TypeSent === "SentAll") {
        this.EditNamePosition = val;
        this.DialogAllEmployee = true;
      } else if (this.TypeSent === "SentId") {
        this.DialogConsentEmployeeId = true;
      }
    },
  },
  watch: {
    TypeSent(val) {
      if (val === "SentAll") {
        this.DisabledPosition = true;
      } else {
        this.ItemsPosition = [];
      }
    },
    SelectDepartment(val) {
      if (val.DepartmentId === "00000") {
        this.DepartmentId = "00000";
        this.DisabledPosition = true;
      } else if (val.DepartmentId) {
        this.$refs.formConsent.resetValidation()
        this.DisabledPosition = false;
        this.Fn_GetDetailDepartment();
      }
    },
    SelectRole(val) {
      this.ItemsPosition = val.Account;
    },
    ConsentType(val) {
      if (val === "SentGeneral") {
        this.TextPolicy = "เลือกนโยบายแบบทั่วไป";
        this.TextConsent = "เลือกความยินยอมแบบทั่วไป";
      } else if (val === "SentGroup") {
        this.TextPolicy = "เลือกนโยบายแบบกลุ่ม";
        this.TextConsent = "เลือกความยินยอมแบบกลุ่ม";
      }
    },
    SelectNamePosition(val) {
      if (val.length == 0) {
        this.ShowDetails = false;
        this.ShowSendBtn = false;
      } else {
        this.ShowDetails = true;
        this.ShowSendBtn = true;
      }
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.hover:hover {
  background-color: #ddf7ff;
}
</style>
